import { ILLGenericKeys, ILLPackage, ILLPackageMarketing } from './index';

export class ILLPackageConfigurations {
 packageConfigurationId: number;
 packageConfigurationName: string;
 packages: ILLPackage[];
 defaultStrengthDenominatorUnit: ILLGenericKeys;
 combinationProductType: ILLGenericKeys;
 packageMarketing: ILLPackageMarketing;
 isSamplePackaging: boolean;
}